import validator from 'validator';

export const isValidPassword = (password, options = { minLength: 10 }) => {
  if (!password || password.includes(' ')) return false;
  return validator.isStrongPassword(password, options);
};
